import api from '@/lib/axios';

export const inventarioService = {
  async getMovements(productId?: string, companyId?: string, params?: { type?: string; branchId?: string; page?: number; limit?: number }) {
    const response = await api.get('/inventory/movements', {
      params: { productId, companyId, ...params },
    });
    return response.data;
  },

  async adjust(data: {
    companyId: string; branchId: string; productId: string; quantity: number; reason: string; type?: string;
  }) {
    const response = await api.post('/inventory/adjust', data);
    return response.data;
  },

  async getStockInfo(productId: string, companyId: string, branchId?: string) {
    const response = await api.get(`/inventory/stock/${productId}`, { params: { companyId, branchId } });
    return response.data;
  },
};
